import React from 'react';
import styled, { keyframes } from 'styled-components';
import visual02Pc from '../../assets/images/visual02_pc.png';
import visual02Mo from '../../assets/images/visual02_mo.png';
import { Reveal, Section, SectionInner } from '../section/common';
import {
  useMediaQuery,
  useScrollReveal,
  useTypingText,
} from '../../hooks/useScrollReveal';

const ExperienceWrapper = styled(Section)`
  padding: 80px 0 120px;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 30px 0 80px;
  }
`;

const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
  align-items: flex-start;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    grid-template-columns: 1fr;
    gap: 32px;
  }
`;

const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    gap: 24px;
  }
`;

const TitleLine = styled.h2`
  color: #111;
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: 54px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 70.2px */
  letter-spacing: -1.35px;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 32px;
  }
`;

const TitleLineHighlight = styled.span`
  display: inline-block;
  color: #d3ee34;
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: 54px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%;
  letter-spacing: -1.35px;
  background: #111;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 32px;
  }
`;

const blink = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
`;

const TypingCursor = styled.span`
  display: inline-block;
  width: 3px;
  height: 0.95em;
  margin-left: 4px;
  background: #d3ee34;
  vertical-align: -0.08em;
  animation: ${blink} 0.8s step-end infinite;
`;

const Description = styled.p`
  color: #555;
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%; /* 25.2px */
  letter-spacing: -0.45px;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 15px;
    letter-spacing: -0.38px;

    br {
      display: none;
    }
  }
`;

const VisualImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 24px;
  display: block;
`;

const ExperienceSection: React.FC = () => {
  const { ref, isVisible } = useScrollReveal();
  const isMobile = useMediaQuery('(max-width: 768px)');
  const { displayed, isComplete } = useTypingText('브랜드 파트너', isVisible);

  return (
    <ExperienceWrapper>
      <SectionInner ref={ref}>
        <Reveal $visible={isVisible}>
          <ContentGrid>
            <TextBlock>
              <div>
                <TitleLine>콘텐츠를</TitleLine>
                <TitleLine>경험으로 확장하는</TitleLine>
                <TitleLineHighlight>
                  {displayed}
                  {!isComplete && <TypingCursor aria-hidden />}
                </TitleLineHighlight>
              </div>
              <Description>
                콘텐츠에서 시작된 관심이 체험과 참여로 이어질 때
                <br />
                브랜드의 영향력은 더욱 커집니다.
                <br />
                이제 라라팡과 그 과정을 함께 하세요.
              </Description>
            </TextBlock>
            <VisualImage
              src={isMobile ? visual02Mo : visual02Pc}
              alt="콘텐츠를 경험으로 확장하는"
            />
          </ContentGrid>
        </Reveal>
      </SectionInner>
    </ExperienceWrapper>
  );
};

export default ExperienceSection;
